export const BASE_URL = "https://water-tracker-backend-101-team-5.onrender.com";
